import { Observable } from 'rxjs';

export const AUTH_REPOSITORY = 'AuthRepository';

export interface AuthRepository {
  logout(): Observable<any>;
}
